import * as React from 'react';
import * as logoImage from './airstream-logo.png';

const InlineLogoPNG = ({ className = '' }) => (
	<img src={logoImage} alt="Airstream Logo" className={className} />
);

export default InlineLogoPNG;
